export class PromoCodesVisibilityService {
  constructor(private shouldHidePromoCodes: boolean) {}

  public api() {
    return {};
  }

  public data() {
    return {
      shouldHide: () => this.shouldHidePromoCodes,
    };
  }

  public handlers() {
    return {};
  }
}
